export default "__VITE_ASSET__f9lLsTag__"